export  class DirectDebitfileConfigModel {
    public directDebitfileConfigHashId: string;
    public enableFileGeneration: boolean=false;
    public fileLevel: string;
    public companyName: string;
    public address: string;
    public iBANNumber: string;
    public countryCode: string="NL";
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/instance/models/direct-debitfile-config.model.ts